class AccountSettings.MailProfileImageUploaderView extends Backbone.View
  template: JST["backbone/templates/account_settings/social_accounts/mail_profile_image"]


  render: ->
    @$el.html(@template)
    @attachment = new AccountSettings.MailImageUploadView(@$el.find('#image-uploader'), @)
    @attachment.render()
    return this

  addLabel: (label) ->
    @$el.find("#no-image-container").hide()
    @$el.find("#images-container").append(label.render())
  
  removeLabel: ->
    @$el.find("#no-image-container").show()

  loadExternalImage: (url) ->
    @attachment.addExternalImage(url)